import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField.tsx';
import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import {
  selectForwardAccumulatorProperty,
  selectForwardAccumulatorValidation,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const AkoTrigger = () => {
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const akoTrigger = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'akoTrigger'));

  const validation = useAppSelector((state) => selectForwardAccumulatorValidation(state, tileId));

  const handleAko = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent(
      'Forward Accumulator',
      'AKO trigger changed',
      isDefined(value) ? value.toString() : 'cleared',
    );

    return check({
      akoTrigger: isDefined(value) ? value : null,
    });
  };

  return (
    <FormField formattedMessageId="forwardAccumulator.form.akoTrigger">
      <TradeCaptureValidationWrapper validation={validation?.akoTrigger}>
        <SgNumberInput
          valuePosition="start"
          selectAllOnFocus
          value={akoTrigger}
          maxDecimals={9}
          onChange={handleAko}
          size="sm"
          data-e2e="ako-trigger"
        />
      </TradeCaptureValidationWrapper>
    </FormField>
  );
};

export default AkoTrigger;
